/**
 * Import assets
 */
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import PopUp from '../elements/PopUp';
import NextStep from '../elements/NextStep';
import { CSSTransition } from 'react-transition-group';

import MapView from '../elements/MapView';
import MapElement from '../elements/MapElement';
import MapEconomy from '../elements/MapEconomy';
import MapPolicy from '../elements/MapPolicy';
import Defines from '../../Defines';
import Warning from "../../assets/img/icons/warning.svg";
import {
  getUnreadCount,
  unreadCount,
  getEconomieFeedback,
  ministryHasDisaster,
  getPolicyChoiceFeedback,
  getPolicyChoiceTotalPoints, getLowMinistryFeedbackLink,
} from '../../helpers/feedbackHelpers';
import { getTotalCosts, choicesToMake } from '../../helpers/policyChoiceHelper';
import {
  getMinistryGlobasSpent
} from '../../helpers/calculationsHelper';

import Logo from '../../assets/img/logo.png';

import { __, __n } from 'i18n-for-browser';
import DifficultyAwareComponent from "../DifficultyAwareComponent";

class Home extends DifficultyAwareComponent {
  static propTypes = {
    history: PropTypes.shape({}).isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      tour: false,
      tourPopUpCount: 0,
      lowBudgetWarning: true,
      showWarning: '',
      tourPopups: [
        {
          title: 'Welkom in Globaland',
          nextUpType: 'nextPopUp',
          img: Logo,
          buttonText: __('sim_volgende_button'),
          align: 'center'
        },
        {
          title: 'Om te beginnen',
          description: 'Bedenk een leuke naam voor jullie land en upload je teamfoto. \n\n Let op: alleen de teamleider kan informatie invoeren. De overige teamleden kunnen alleen informatie bekijken. Je kunt per spelronde wisselen van rol.',
          nextUpType: 'nextPopUp',
          buttonText: __('sim_volgende_button'),
        },
        {
          title: 'Land besturen',
          description: 'In deze app kun je je land besturen. Elke spelronde bestaat uit 3 stappen: 1. Hoe staat je land ervoor? 2. Belasting heffen 3. Budget verdelen Op sommige plekken kun je pas verder als alle groepen van de klas klaar zijn of als de begeleider het vervolg heeft geactiveerd.',
          nextUpType: 'close',
          buttonText: __('sim_sluiten'),
        }
      ]
    };
    this.toggleTourPopUp = this.toggleTourPopUp.bind(this);
  }

  toggleTourPopUp = (direction) => {
    if (direction === "prev" && this.state.tourPopUpCount > 0) {
      if (this.state.tourPopups[(this.state.tourPopUpCount - 1)]) {
        this.setState({
          tourPopUpCount: (this.state.tourPopUpCount - 1)
        });
      }
    } else {
      if (this.state.tourPopups[(this.state.tourPopUpCount + 1)]) {
        this.setState({
          tourPopUpCount: (this.state.tourPopUpCount + 1)
        });
      } else {
        this.setState({
          tour: false
        });
      }
    }
  };

  allowSave = () => {
    const { gameState, gameStateInput, policyChoice } = this.props;
    if (gameState.difficulty === 'BASIC' && choicesToMake(policyChoice, gameStateInput.myState.policyChoices, this.props.project.minPolicyChoices) > 0) {
      return false;
    }
    return true;
  }

  deselect = (isHighlighted) => {
    console.log(isHighlighted);
  }

  renderLaag() {
    const position = Defines.position;
    const {
      tour,
    } = this.state;
    let currentPopUp = this.state.tourPopups[this.state.tourPopUpCount];
    const { gameState, feedback, myState, policyChoice } = this.props;
    const { prevRoundSum, currentRound } = gameState;
    if (!prevRoundSum) return null;
    const niveau = this.props.project.difficulty.toLowerCase();
    const budget = gameState.totalGameStateSum.globas;
    const currentRoundGameState = gameState.Rounds[currentRound];

    let currentMin = this.props.currentMin;
    if (this.props.history.location.pathname.toLowerCase().indexOf('beleidskeuzes') > -1) {
      currentMin = 'beleidskeuzes';
    }

    if (this.props.history.location.pathname.toLowerCase().indexOf('economy') > -1) {
      currentMin = 'economy';
    }

    //Redirect to feedbackitem when solely the ministry is selected
    if (this.props.currentMin) {
      const target = getLowMinistryFeedbackLink(this.props.feedback.prevRoundFeedbackData, this.props.currentMin, this.props.gameState, this.props.gameStateInput, true);
      if (target.length > 0) {
        this.props.history.push(target[0]);
      }
    }

    return (
      <div className={'home-map step-' + gameState.currentStep}>
        <CSSTransition
          in={tour}
          timeout={200}
          classNames="animation"
          unmountOnExit>
          {state => (
            <PopUp
              title={currentPopUp.title}
              description={currentPopUp.description}
              img={currentPopUp.img}
              align={currentPopUp.align}
              nextUpType={currentPopUp.nextUpType}
              buttonText={currentPopUp.buttonText}
              showPopUp={this.state.tour}
              nthPopup={this.state.tourPopUpCount}
              nPopups={this.state.tourPopups.length}
              closePopUpClick={this.toggleTourPopUp}
              navigation={true} />
          )}
        </CSSTransition>
        <MapView
          history={this.props.history}
          unHighlight={!!currentMin}>
          {gameState.currentStep !== 3 ?
            <MapEconomy
              target={(currentMin === 'economy' ? '/' : '/economy/total')}
              title={__("sim_economie")}
              top={position["economy"]['basic']["top"]}
              left={
                (!(gameState.currentStep === 1 && gameState.currentRound > 1 && this.props.project.minPolicyChoices > 0) && gameState.currentStep !== 3 ? (
                  position["economy"]['pro']["left"]
                ) : (
                  position["economy"]['basic']["left"]))
              }
              history={this.props.history}
              roundPoints={currentRoundGameState.earnedPoints}
              economy={gameState.totalEconomy}
              feedbackCount={unreadCount(getEconomieFeedback(feedback.prevRoundFeedbackData), true)}
              unHighlight={currentMin ? (currentMin).toLowerCase() !== 'economy' : ''}
            /> : ''
          }
          {
            !(gameState.currentStep === 1 && gameState.currentRound > 1) && gameState.currentStep !== 3 ? null : (
              this.props.project.minPolicyChoices > 0 ? (
                <MapPolicy
                  title={__n('sim_beleidskeuze', 0)}
                  target={(currentMin === 'beleidskeuzes' ? '/' : '/beleidskeuzes')}
                  step={gameState.currentStep}
                  top={gameState.currentStep === 3 ? position["economy"]['pro']["top"] : position["policy"]["top"]}
                  left={gameState.currentStep === 3 ? position["economy"]['pro']["left"] : position["policy"]["left"]}
                  number={gameState.currentStep === 3 ? getTotalCosts(myState.policyChoices, policyChoice) : getPolicyChoiceTotalPoints(feedback.prevRoundFeedbackData)}
                  suffix={gameState.currentStep === 3 ? __('sim_miljard') : __('sim_punten')}
                  history={this.props.history}
                  feedbackCount={
                    gameState.currentStep === 3
                      ? choicesToMake(policyChoice, myState.policyChoices, this.props.project.minPolicyChoices)
                      : unreadCount(getPolicyChoiceFeedback(feedback.prevRoundFeedbackData), null, true)
                  }
                  unHighlight={currentMin ? (currentMin).toLowerCase() !== 'beleidskeuzes' : ''}
                />
              ) : null
            )
          }
          {Defines.basic.ministries.map(min => (
            <MapElement
              key={min}
              targetz={`/ministries/${gameState.currentStep === 3 ? 'budget/' : ''}${min.toLowerCase()}`}
              target={(gameState.currentStep === 3 ?
                '/ministries/budget/' + min.toLowerCase()
                :
                (getLowMinistryFeedbackLink(this.props.feedback.prevRoundFeedbackData, min, this.props.gameState, this.props.gameStateInput).length > 0 ?
                  getLowMinistryFeedbackLink(this.props.feedback.prevRoundFeedbackData, min, this.props.gameState, this.props.gameStateInput)[0]
                  :
                  '/ministries/' + min.toLowerCase()
                )
              )
              }
              title={__(min)}
              icon={min}
              value={gameState.gameStateSum[`${min}_value`]}
              stars={false}
              international={Defines.i18nMinistries.includes(min)}
              top={position[min]["basic"]["top"]}
              left={position[min]["basic"]["left"]}
              globas={getMinistryGlobasSpent(myState.ministerieGlobaVerdeling, min, gameState.currentStep)}
              feedbackCount={
                getUnreadCount(min, this.props.feedback.prevRoundFeedbackData)
              }
              difficulty={niveau}
              roundPoints={prevRoundSum[`${min}_points`]}
              budgetSet={false}
              policySet={false}
              disaster={ministryHasDisaster(min, this.props.feedback)}
              history={this.props.history}
              unHighlight={currentMin ? (currentMin).toUpperCase() !== min : ''}
            />
          ))}
        </MapView>
        {gameState.currentStep === 3 && gameState.currentRound < 4 && this.state.lowBudgetWarning && budget < 30 && !this.props.gameState.history && this.props.project.bankEnabled !== false ? (
          <PopUp
            img={Warning}
            className={'desktopMapBottom'}
            popUpFooter={true}
            description={__('sim_beperkt_budget_melding')}
            showIfUnread={`${gameState.currentRound}-limitedBudget`}
            closePopUpCross={true}
            closePopUpClick={() => this.setState({ lowBudgetWarning: false })} />
        ) : null}
        {this.state.showWarning.length ? (
          <PopUp
            img={Warning}
            className={'desktopMapBottom'}
            popUpFooter={true}
            description={__(this.state.showWarning)}
            closePopUpClick={() => this.setState({ showWarning: '' })}
          />
        ) : null}
        <NextStep />
      </div>
    );
  }

  renderHoog() {
    const position = Defines.position;

    const {
      tour,
    } = this.state;
    let currentPopUp = this.state.tourPopups[this.state.tourPopUpCount];
    const { gameState, myState, feedback } = this.props;
    const { prevRoundSum } = gameState;
    if (!prevRoundSum) return null;
    const niveau = this.props.project.difficulty.toLowerCase();
    const { ministerieGlobaVerdeling } = myState;

    const myPolicyChoices = Object.values(myState.policyChoices);
    const budget = gameState.totalGameStateSum.globas;
    let currentMin = this.props.currentMin;
    if (this.props.history.location.pathname.toLowerCase().indexOf('economy') > -1) { currentMin = 'economy' }
    if (this.props.history.location.pathname.toLowerCase().indexOf('loss') > -1) { currentMin = 'loss' }
    if (this.props.history.location.pathname.toLowerCase().indexOf('profit') > -1) { currentMin = 'profit' }
    if (this.props.history.location.pathname.toLowerCase().indexOf('earned') > -1) { currentMin = 'earned' }

    return (
      <div className={'home-map step-' + gameState.currentStep}>
        <CSSTransition
          in={tour}
          timeout={200}
          classNames="animation"
          unmountOnExit>
          {state => (
            <PopUp
              title={currentPopUp.title}
              description={currentPopUp.description}
              img={currentPopUp.img}
              align={currentPopUp.align}
              nextUpType={currentPopUp.nextUpType}
              buttonText={currentPopUp.buttonText}
              showPopUp={this.state.tour}
              nthPopup={this.state.tourPopUpCount}
              nPopups={this.state.tourPopups.length}
              closePopUpClick={this.toggleTourPopUp}
              navigation={true} />
          )}
        </CSSTransition>
        <MapView
          history={this.props.history}
          unHighlight={!!currentMin}
          onClick={_ => (this.deselect(!!currentMin))}>
          {gameState.currentStep !== 3 ? <MapEconomy
            to='/economy/total'
            target={(currentMin === 'economy' ? '/' : '/economy/total')}
            title={__("sim_economie")}
            top={position["economy"]["pro"]["top"]}
            left={position["economy"]["pro"]["left"]}
            roundPoints={gameState.Rounds[gameState.currentRound].earnedPoints}
            economy={gameState.totalEconomy}
            history={this.props.history}
            feedbackCount={unreadCount(getEconomieFeedback(feedback.prevRoundFeedbackData), true)}
            unHighlight={currentMin ? !['economy', 'profit', 'loss', 'earned'].includes((currentMin).toLowerCase()) : ''}
          /> : null}
          {Defines.pro.ministries.map(min => (
            <MapElement
              key={min}
              target={`/ministries/${gameState.currentStep === 3 ? 'budget/' : ''}${min.toLowerCase()}`}
              title={__(min)}
              icon={min}
              value={gameState.gameStateSum[`${min}_value`]}
              stars={Defines.ministeryStars[min]}
              international={Defines.i18nMinistries.includes(min)}
              top={position[min]["pro"]["top"]}
              left={position[min]["pro"]["left"]}
              feedbackCount={
                getUnreadCount(min, this.props.feedback.prevRoundFeedbackData)
              }
              difficulty={niveau}
              globas={getMinistryGlobasSpent(ministerieGlobaVerdeling, min, gameState.currentStep, myPolicyChoices)}
              roundPoints={prevRoundSum[`${min}_points`]}
              budgetSet={ministerieGlobaVerdeling[min] && gameState.currentStep > 1}
              policySet={myPolicyChoices.find(choice => choice.ministry === min && choice.selected) && gameState.currentStep > 1}
              history={this.props.history}
              disaster={ministryHasDisaster(min, this.props.feedback)}
              unHighlight={currentMin ? (currentMin).toUpperCase() !== min : ''}
            />
          ))}
        </MapView>
        {gameState.currentStep === 3 && gameState.currentRound < 4 && this.state.lowBudgetWarning && budget < 250 && !this.props.gameState.history ? (
          <PopUp
            className={'desktopMapBottom'}
            img={Warning}
            popUpFooter={true}
            description={__('sim_beperkt_budget_melding')}
            showIfUnread={`${gameState.currentRound}-limitedBudget`}
            closePopUpCross={true}
            closePopUpClick={() => this.setState({ lowBudgetWarning: false })} />
        ) : null}
        {this.state.showWarning.length ? (
          <PopUp
            className={'desktopMapBottom'}
            img={Warning}
            popUpFooter={true}
            description={__(this.state.showWarning)}
            closePopUpClick={() => this.setState({ showWarning: '' })}
          />
        ) : null}
        <NextStep />
      </div>
    );
  }
}

export default connect(({ gameState, user, gameStateInput, feedback, project, policyChoice }) => ({ gameState, user, gameStateInput, myState: gameStateInput.myState, feedback, project, policyChoice }))(Home);



// WEBPACK FOOTER //
// ./src/components/desktop/Home.js